export default __webpack_public_path__ + "images/LE.9e08198.png";